import React, {Component} from 'react';
import classNames from 'classnames';
import * as R from 'ramda';

import 'scss/layout.scss';
import './index.scss';

export default class FeedbackForm extends Component {
    static defaultProps = {
        onSelect: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            values: {}
        };
    }

    onSelect(id) {
        const {onSelect} = this.props;
        this.setState(
            R.evolve({
                values: R.over(R.lensProp(id), R.not)
            }),
            () => onSelect(this.state.values)
        );
    }

    renderOption = ({id, text, icon}) => {
        const {values} = this.state;
        const classes = classNames('layout-stack', 'feedback-form__option', {
            'feedback-form__option--selected': values[id]
        });
        return (
            <button key={id} className={classes} onClick={() => this.onSelect(id)}>
                <i className={classNames('feedback-form__option__icon', `icon-${icon}`)} />
                <div className="feedback-form__option__text">{text}</div>
            </button>
        );
    };

    render() {
        const {options, usesTextarea, onTextChange} = this.props;
        const freeformFeedback = usesTextarea ? (
            <textarea className="feedback-form__freeform-input" onChange={onTextChange} />
        ) : (
            <input className="feedback-form__freeform-input" type="text" onChange={onTextChange} />
        );

        return (
            <div className="layout-stack feedback-form">
                <div className="layout-side-by-side feedback-form__options">
                    {R.map(this.renderOption, options)}
                </div>
                <div className="feedback-form__text">
                    <label className="feedback-form__label">
                        Other Feedback:
                        {freeformFeedback}
                    </label>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/feedback_form/index.js